import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const scanConfig = async (userId, credentials) => {
  if (!userId || !credentials) {
    throw {
      message: "User ID and credentials are required",
      code: "INVALID_INPUT",
      card: false
    };
  }

  try {
    const token = sessionStorage.getItem('authToken');
    if (!token) {
      throw {
        message: "Authentication token is missing",
        code: "UNAUTHORIZED",
        card: false
      };
    }

    const response = await fetch(`${api_base_url}/api/${api_key}/post/${userId}/azure/scanConfig`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ credentials }),
    });

    const data = await response.json();
    if (!response.ok || data.success === false) {
      throw {
        message: data.message || "Request failed",
        code: data.code || "UNKNOWN_ERROR",
        card: data.meta?.showUpgradeCard || false
      };
    }

    return data;
  } catch (error) {
    console.error('Error during AZURE scan:', error);
    throw error;
  }
};

export const scanBlobUrl = async (userId, url) => {
  if (!userId || !url) {
    throw {
      message: "User ID and URL are required",
      code: "INVALID_INPUT",
      card: false
    };
  }
  
  try {
    const token = sessionStorage.getItem('authToken');
    if (!token) {
      throw {
        message: "Authentication token is missing",
        code: "UNAUTHORIZED",
        card: false
      };
    }
    
    const response = await fetch(`${api_base_url}/api/${api_key}/post/${userId}/azure/scanBlobUrl`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ url }),
    });

    const data = await response.json();
    if (!response.ok || data.success === false) {
      throw {
        message: data.message || "Request failed",
        code: data.code || "UNKNOWN_ERROR",
        card: data.meta?.showUpgradeCard || false
      };
    }

    return data;
  } catch (error) {
    console.error('Error during AZURE scan:', error);
    throw error;
  }
};

export const scanVmsIp = async (userId, ip) => {
  if (!userId || !ip) {
    throw {
      message: "User ID and IP are required",
      code: "INVALID_INPUT",
      card: false
    };
  }

  try {
    const token = sessionStorage.getItem('authToken');
    if (!token) {
      throw {
        message: "Authentication token is missing",
        code: "UNAUTHORIZED",
        card: false
      };
    }
    
    const response = await fetch(`${api_base_url}/api/${api_key}/post/${userId}/azure/scanVmsIp`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ ip }),
    });

    const data = await response.json();
    if (!response.ok || data.success === false) {
      throw {
        message: data.message || "Request failed",
        code: data.code || "UNKNOWN_ERROR",
        card: data.meta?.showUpgradeCard || false
      };
    }

    return data;
  } catch (error) {
    console.error('Error during AZURE scan:', error);
    throw error;
  }
};

export const checkIpType = async (ip, d_id) => {
  try {
    const response = await fetch(`${api_base_url}/api/${api_key}/${d_id}/network/azure/checkIpType`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ip}),
    });
    
    const data = await response.json();   
    return data;  
  } catch (err) {
    throw new Error(err.message);  
  }
};
